import { AlertTriangle } from 'lucide-react';

export default function CookieWall() {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="w-full max-w-md rounded-xl bg-warm-white dark:bg-gray-900 shadow-2xl p-8 text-center">
        <AlertTriangle className="mx-auto mb-4 h-10 w-10 text-amber-500" />
        <h2 className="font-playfair text-2xl font-semibold text-charcoal dark:text-gray-100 mb-3">
          Cookies are disabled
        </h2>
        <p className="text-sm text-muted-foreground mb-2 leading-relaxed">
          This site requires cookies to function. Please enable cookies in your
          browser settings and reload the page.
        </p>
      </div>
    </div>
  );
}
